export const defaultProductGalleryModelData = {
  isLayoutChanged: false
};

export const KeyboardKey = {
  ENTER: `Enter`
};

export const NAVIGATION_CHANGE_MEDIA_QUERY = `(max-width: 960px)`;

export const ActionType = {
  CHANGE_LAYOUT: `CHANGE_LAYOUT`
};
